import * as types from "../action/ActionType";
import { SORT_INITIAL } from "../store/InitialStore";
export default function SortReducer(state = SORT_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.SORT_PARAMS:
      return (state = payload);
    default:
      return state;
  }
}
